import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      display: 'flex',
      alignItems: 'center',
      gap: 32,
    },
    control: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    label: {
      fontSize: 12,
      fontWeight: 700,
      lineHeight: '140%',
      color: '#000',
    },
    control__body: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      height: 30,
      '& span': {
        fontSize: 21,
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '140%',
        color: '#1A0063',
        height: '100%',
      },
      '& div': {
        height: '100%',
      },
    },
  })
)
export default useStyles
